// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-bottom[data-v-edbb25a2] {\n    background-color: #f8f8f8;\n    padding: 4px 0;\n}\nbutton[data-v-edbb25a2] {\n    font-size: 16px;\n    min-width: 180px;\n}\n/*\n.btn-orange{\n    background-color: rgb(255, 136, 0);\n    color:white\n}\n\n.btn-orange:hover{\n    background-color: rgb(255, 95, 2);\n    color:white\n}\n.btn-orange:disabled{\n    background-color: rgb(255, 136, 0);\n    color:white\n}\n*/", ""]);
// Exports
module.exports = exports;
